import { Close as RadixClose, type DialogCloseProps as RadixCloseProps } from "@radix-ui/react-dialog";
import { forwardRef } from "react";

type Props = RadixCloseProps;

const Close = forwardRef<HTMLButtonElement, Props>((props, forwardedRef) => (
    <RadixClose {...props} ref={forwardedRef} />
));

Close.displayName = "Dialog.Content.Actions.Close";

export { Close as DialogContentActionsClose };
export type { Props as DialogContentActionsCloseProps };
